import { createContext, useContext } from 'react';
import type { MobileTheme } from './constants';

export interface MobilePreviewContextValue {
  mobileTheme: MobileTheme;
  setMobileTheme: (theme: MobileTheme) => void;
}

/**
 * The phone's theme, shared by everything drawn inside (and above)
 * the frame. Defaults to a light phone that cannot be toggled, so a
 * preview part rendered outside a provider still looks right.
 */
export const MobilePreviewContext = createContext<MobilePreviewContextValue>({
  mobileTheme: 'light',
  setMobileTheme: () => {},
});

export const useMobilePreview = () => useContext(MobilePreviewContext);
